import{useEffect as o}from"react";const r=r=>{o((()=>{r()}),[])};export{r as useDidMount};
